export type ScrollTo = string;

export type LocalStorageTypes =
    | ScrollTo;

export enum LOCAL_STORAGE_NAMES {
    SCROLL_TO = 'scrollTo',
}
